
export const workshopCardStyle = {
    backgroundColor: 'white',
    padding: 2,
    borderRadius: 2, // 2 = 16px (default theme spacing unit * 0.5)
};

export const workshopCardHeaderStyle = {
    marginBottom: -2,
};